export default {
	"e31734d7c1b1ece7e89c6f860438f113": "確認訂單收銀台-收銀台浮層",
	"5d9d1694e5328a1e252676608ba51256": "支付金額",
	"035d0f9a012bbc74df08c66c8c32491b": "支付寶",
	"91b2ef6547c20214f5c1cfb548a9adab": "微信支付",
	"6048b9df0c43aeda0116eca3c6fcc969": "支付寶掃碼付",
	"fe66e8c2346b3d606274bec0555c4734": "支付寶 | 先學後付"
}
